import { type TrackingProperties, trackEvent } from '@lib/tracking'
import { TrackingEvents } from '@lib/tracking/TrackingEvents'
import { TrackingSources } from '@lib/tracking/TrackingSources'

export enum ApplyFlowSection {
  APPLY_RECOMMENDATIONS = 'apply-recommendations',
  CONDITIONS = 'conditions',
  DEMOGRAPHICS = 'demographics',
  LOCATIONS = 'locations',
  POSTSCREENER = 'postscreener',
  POST_APPLY = 'post-apply',
  PRESCREENER = 'prescreener',
  PRESCREENER_VERIFIER = 'prescreener-verifier',
  TRIAL_APPLY = 'trial-apply',
}

export const ApplyFlowSectionScore: Record<ApplyFlowSection, number> = {
  [ApplyFlowSection.APPLY_RECOMMENDATIONS]: 800,
  [ApplyFlowSection.CONDITIONS]: 400,
  [ApplyFlowSection.DEMOGRAPHICS]: 200,
  [ApplyFlowSection.LOCATIONS]: 300,
  [ApplyFlowSection.POSTSCREENER]: 700,
  [ApplyFlowSection.POST_APPLY]: 900,
  [ApplyFlowSection.PRESCREENER]: 500,
  [ApplyFlowSection.PRESCREENER_VERIFIER]: 600,
  [ApplyFlowSection.TRIAL_APPLY]: 100,
}

export function trackApplyFlowStepViewed(props: TrackingProperties) {
  return trackEvent(TrackingEvents.APPLY_FLOW_STEP_VIEWED, {
    ...props,
    source: TrackingSources.APPLY_FLOW_V2,
  })
}
